import { render, staticRenderFns } from "./BunkeringLogTable.vue?vue&type=template&id=60679d32&scoped=true"
import script from "./BunkeringLogTable.vue?vue&type=script&lang=js"
export * from "./BunkeringLogTable.vue?vue&type=script&lang=js"
import style0 from "./BunkeringLogTable.vue?vue&type=style&index=0&id=60679d32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60679d32",
  null
  
)

export default component.exports